import { NotificationCategory } from "../../../types/notificationPreferences";

/**
 * One row of the notification settings (a matrix row on desktop, a line in a
 * staff card on mobile). Category rows come from the backend catalog; the
 * trailing "Email delivery" row is the per-location email channel switch.
 * `description` explains what triggers the row and is shown in its tooltip.
 */
export type PreferenceRow =
  | {
      kind: "category";
      key: string;
      label: string;
      description: string;
      category: NotificationCategory;
    }
  | { kind: "email"; key: string; label: string; description: string };

export const EMAIL_ROW: PreferenceRow = {
  kind: "email",
  key: "email_delivery",
  label: "Email delivery",
  description:
    "When on, the notifications this person receives above are also emailed to them.",
};

export const buildPreferenceRows = (
  categories: NotificationCategory[],
): PreferenceRow[] => [
  ...categories.map(
    (category): PreferenceRow => ({
      kind: "category",
      key: category.key,
      label: category.label,
      description: category.description,
      category,
    }),
  ),
  EMAIL_ROW,
];
